import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import { autoCreateVendorUsers, fetchVendorUsers } from '../feedback-linking.utils';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
        autoCreatingVendorUsers: false,
        autoCreatingVendorUsersError: {},
        autoCreatingVendorUsersResult: {},
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
        setAutoCreatingVendorUsers (state, { autoCreatingVendorUsers }) {
            state.autoCreatingVendorUsers = autoCreatingVendorUsers;
        },
        setAutoCreatingVendorUsersError (state, { autoCreatingVendorUsersError }) {
            state.autoCreatingVendorUsersError = autoCreatingVendorUsersError;
        },
        setAutoCreatingVendorUsersResult (state, { autoCreatingVendorUsersResult }) {
            state.autoCreatingVendorUsersResult = autoCreatingVendorUsersResult;
        },
    },
    actions: {
        loadAll ({ commit, state }, { reFetch = false, vendorUuid } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return Promise.resolve();
            }
            if (!vendorUuid) {
                throw new Error('No vendorUuid Given');
            }
            commit('setFetching', { fetching: true });

            return fetchVendorUsers({ vendorUuid })
                .then(({ data: vendorUsers }) => {
                    commit('setFetching', { fetching: false });
                    commit('setMap', {
                        map: keyBy(vendorUsers, 'uuid'),
                    });
                })
                .catch((error) => {
                    commit('setFetching', { fetching: false });
                    commit('setError', { error });
                    throw error;
                });
        },
        autoCreateUsers ({ commit }, { usersToCreate, vendorUuid } = {}) {
            commit('setAutoCreatingVendorUsers', { autoCreatingVendorUsers: true });
            if (!usersToCreate) {
                throw new Error('No usersToCreate Given');
            }

            if (!vendorUuid) {
                throw new Error('No vendorUuid Given');
            }

            return autoCreateVendorUsers({ usersToCreate, vendorUuid })
                .then(({ data: autoCreatingVendorUsersResult }) => {
                    commit('setAutoCreatingVendorUsers', {
                        autoCreatingVendorUsers: false,
                    });
                    commit('setAutoCreatingVendorUsersResult', { autoCreatingVendorUsersResult });
                })
                .catch((autoCreatingVendorUsersError) => {
                    commit('setAutoCreatingVendorUsers', {
                        autoCreatingVendorUsers: false,
                    });
                    commit('setAutoCreatingVendorUsersError', { autoCreatingVendorUsersError });
                    throw autoCreatingVendorUsersError;
                });
        },
    },
    getters: {
        unLinkedVendorUsersList: (state) => values(state.map).filter((vendorUser) => !vendorUser.pendo_user_id),
        vendorUserByUuid: (state) => (uuid) => state.map[uuid],
        list: (state) => values(state.map),
    },
};
